import { Box } from "@primer/react";
import { DataGrid, DateBox, NumberBox } from "devextreme-react";
import { Button as DevButton } from 'devextreme-react/button';
import { Column, Selection, Summary, TotalItem } from "devextreme-react/data-grid";
import TextBox from "devextreme-react/text-box";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { hinhThucThanhToanApi } from "../../../api/hinhThucThanhToanApi";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { phanBoPhiApi } from "../../../api/phanBoPhiApi";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_hinhthucthanhtoan, sf_hinhthucthanhtoan_sotiennop } from "../../../models/request/hinh-thuc-thanh-toan/sf_hinhthucthanhtoan";
import { sf_phanbophi_viewmodel } from "../../../models/request/phan-bo-phi/sf_phan_bo_phi";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { ts_hocsinh } from "../../../models/response/hocsinh/ts_hocsinh";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import {
    loadThuPhiChiTietStart
} from '../../../state/actions/thuPhiChiTietAction';
import { RootState } from "../../../state/reducers";
import { Button } from "../../buttons";
import { DefaultPopup } from "../../modal";
import "./style.css";
export type ThuPhiHinhThucThuPhiBtnProps = {
    disabled: boolean,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh: ts_hocsinh,
    onChanged: () => void,
    sf_bienlaithu: any
}

const ThuPhiHinhThucThuPhiBtn = (props: ThuPhiHinhThucThuPhiBtnProps) => {
    const dispatch = useDispatch();
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>(false)
    useEffect(() => {
        dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
    }, []);
    return (
        <>
            <DevButton
                text="Hình thức thu phí"
                type="default"
                stylingMode="text"
                icon="plus"
                className="p-btn-devextreme"
                disabled={props.disabled}
                onClick={() => {
                    setIsShowPopUp(true)
                }}
            />
            {isShowPopUp &&
                <ThuPhiHinhThucNopModal
                    onCancel={() => { setIsShowPopUp(false); props.onChanged() }}
                    onSuccess={() => {
                        setIsShowPopUp(false); props.onChanged();
                    }}
                    sf_mucphaithu={props.sf_mucphaithu}
                    sf_bienlaithu={props.sf_bienlaithu}
                    ts_hocsinh={props.ts_hocsinh}
                />}
        </>
    )
}
type ThuPhiHinhThucNopModalProps = {
    ts_hocsinh: any,
    sf_mucphaithu: sf_mucphaithu,
    sf_bienlaithu: any,
    onCancel: () => void,
    onSuccess: () => void
}

const ThuPhiHinhThucNopModal = (props: ThuPhiHinhThucNopModalProps) => {
    const [status, SetStatus] = useState<string>(PageBaseStatus.is_completed)
    const [sf_hinhthucthanhtoans, set_sf_hinhthucthanhtoans] = useState<sf_hinhthucthanhtoan[]>([])
    const [sf_phanbophis, set_sf_phanbophis] = useState<sf_phanbophi_viewmodel[]>([]);
    const [datasource, SetDataSource] = useState<sf_hinhthucthanhtoan_sotiennop[]>([]);
    const { dm_coso_id, nam_hoc } = useSelector((x: RootState) => x.common)
    const [selected, setSelected] = useState<any>([]);
    const [selectedTienThua, setSelectedTienThua] = useState<any>([]);

    const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
    const [tong_tien_thua_temp, set_tong_tien_thua_temp] = useState<any>(0);
    const [tong_tien_tra_truoc, set_tong_tien_tra_truoc] = useState<any>(0);

    const [selectedPayment, setSelectedPayment] = useState<any>([]);

    const onCardClick = (data: any) => {
        setSelected([])
        setSelectedPayment([])
        if (datasource && props.sf_mucphaithu) {
            let a = datasource.map(x => x.so_tien).reduce((a, b) => a + b);
            let b = props.sf_mucphaithu.tong_tien_phai_nop;
            let newData = { ...data };
            newData.ghi_chu = '';
            newData.ma_chuan_chi = '';
            newData.serial = '';
            newData.ngay_thu = moment().format("YYYY-MM-DD HH:mm:ss");
            newData.so_tien = b - a;
            newData.sf_mucphaithu_id = props.sf_mucphaithu.id;
            setSelected(newData);
            setSelectedTienThua([]);
            setSelectedPayment([])
        }
    };

    const handleReloadHinhThucThanhToan = async () => {
        const res = await hinhThucThanhToanApi.select_all();
        set_sf_hinhthucthanhtoans(res.data.filter((x: any) => x.dm_coso_id === dm_coso_id))
    }
    const handleReloadPhanBoPhi = async () => {
        const res = await phanBoPhiApi.select_by_sct(props.sf_mucphaithu.id);
        set_sf_phanbophis(res.data)
    }
    const handleReloadTienThuaHocSinh = async () => {
        const datasend: sf_mucphaithu_select_byhocsinh_rq = { ts_hocsinh_id: props.ts_hocsinh.id, nam_hoc: nam_hoc }
        const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
        if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
            set_tong_tien_thua(res.data.tong_tien_thua)
        }
    }
    useEffect(() => {
        handleReloadHinhThucThanhToan();
        handleReloadPhanBoPhi();
        handleReloadTienThuaHocSinh();
    }, []);
    useEffect(() => {
        if (tong_tien_thua && selectedTienThua.so_tien >= 0) {
            set_tong_tien_thua_temp(tong_tien_thua - selectedTienThua.so_tien)
        }
        else {
            set_tong_tien_thua_temp(tong_tien_thua)
        }
    }, [tong_tien_thua, selectedTienThua]);
    useEffect(() => {
        if (sf_phanbophis.length > 0) {
            const tong_tien_tra_truoc = sf_phanbophis
                .filter((x: any) => x.hinh_thuc_thanh_toan.toLowerCase().includes("trả trước"))
                .reduce((sum: number, item: any) => sum + item.so_tien, 0);

            set_tong_tien_tra_truoc(tong_tien_tra_truoc);
        } else {
            set_tong_tien_tra_truoc(0);
        }
    }, [sf_phanbophis]);

    useEffect(() => {
        const source = sf_hinhthucthanhtoans.map(x => {
            let item: sf_hinhthucthanhtoan_sotiennop = {
                ...x,
                ma_chuan_chi: "",
                sf_phanbophi_id: 0,
                so_tien: 0,
                sf_mucphaithu_id: props.sf_mucphaithu.id,
                so_batch: '',
                dm_coso_id: dm_coso_id,
                noi_dung_thu_tien: '',
                so_phieu: 0,
                phi_quet_the: 0,
                ghi_chu: '',
                ngoai_te: '',
                ty_gia: '',
                so_tien_ngoai_te: 0,
                so_tien_thua: 0,
                ngay_thu: moment().format("YYYY-MM-DD HH:mm:ss"),
                sf_hinhthucthanhtoan_id: x.id
            }
            const _sf_phanbophis = sf_phanbophis.find((y: any) => y.sf_hinhthucthanhtoan_id === x.id);
            if (_sf_phanbophis) {
                item = { ...item, so_tien: _sf_phanbophis.so_tien, ma_chuan_chi: _sf_phanbophis.ma_chuan_chi, so_batch: _sf_phanbophis.so_batch, dm_coso_id: _sf_phanbophis.dm_coso_id, noi_dung_thu_tien: _sf_phanbophis.noi_dung_thu_tien, so_phieu: _sf_phanbophis.so_phieu, phi_quet_the: _sf_phanbophis.phi_quet_the, ghi_chu: _sf_phanbophis.ghi_chu, ngoai_te: _sf_phanbophis.ngoai_te, ty_gia: _sf_phanbophis.ty_gia, so_tien_ngoai_te: _sf_phanbophis.so_tien_ngoai_te, ngay_thu: _sf_phanbophis.ngay_thu == "0001-01-01T00:00:00" ? moment().format("YYYY-MM-DD HH:mm:ss") : _sf_phanbophis.ngay_thu }
            } else {
                item = { ...item, so_tien: 0, ma_chuan_chi: "", so_batch: '', dm_coso_id: dm_coso_id, noi_dung_thu_tien: '', so_phieu: 0, phi_quet_the: 0, ghi_chu: '', ngoai_te: '', ty_gia: '', so_tien_ngoai_te: 0, so_tien_thua: 0, ngay_thu: moment().format("YYYY-MM-DD HH:mm:ss") };

            }
            return item;
        });

        SetDataSource(source)
    }, [sf_hinhthucthanhtoans, sf_phanbophis]);



    const handleSaveChanges = async () => {
        if (selected.is_have_ma_chuan_chi && selected.ma_chuan_chi === '') {
            showNotify({ message: "Vui lòng điền mã chuẩn chi cho hình thức thu quẹt thẻ", type: "warning" });
            return false;
        } else {
            SetStatus(PageBaseStatus.is_saving);
            let updatedSelected = { ...selected };
            updatedSelected.sf_hinhthucthanhtoan_id = selected.sf_hinhthucthanhtoan_id;
            updatedSelected.hinh_thuc_thanh_toan = selected.hinh_thuc_thanh_toan;
            if (selectedTienThua.so_tien > 0) {
                updatedSelected.so_tien = selectedTienThua.so_tien;
                setSelected(updatedSelected); // Cập nhật state với dữ liệu mới
            }
            console.log("Updated", updatedSelected);
            // Sử dụng updatedSelected để gọi API thay vì selected
            const res = await phanBoPhiApi.save_changes(updatedSelected);

            if (res.is_success) {
                SetStatus(PageBaseStatus.is_completed);
                showNotify({ message: "Cập nhật thành công", type: "success" });
                SetStatus(PageBaseStatus.is_need_reload);
            } else {
                SetStatus(PageBaseStatus.is_completed);
                showNotify({ message: res.message || "Cập nhật thất bại", type: "warning" });
            }
        }

        setSelected([]); // Đặt lại selected sau khi mọi thứ hoàn tất
        handleReloadPhanBoPhi();
        handleReloadTienThuaHocSinh();
    };



    const ListHinhThucThanhToan = () => {
        return (
            <div>
                <div className="payment-wrapper">
                    <div className="payment-container">
                        {datasource.map((x: any) => (
                            <HinhThuc
                                key={x.id}
                                data={x}
                                onClick={() => onCardClick(x)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    const HinhThuc = ({ data, onClick }: { data: any; onClick: () => void }) => {
        return (
            <div
                className={`hinhthuc-container ${selected.sf_hinhthucthanhtoan_id === data.sf_hinhthucthanhtoan_id ? 'selected' : ''}`}
                onClick={onClick}
                style={{ display: 'flex', alignItems: 'center', padding: '5px', cursor: 'pointer', marginBottom: '5px' }}>
                <img
                    src={`${data.img}`}
                    alt="Hình thức"
                    style={{ width: 'auto', height: '25px', marginRight: '8px' }}
                />
                <span className="pay_method">
                    {data.hinh_thuc_thanh_toan}
                </span>
            </div>

        );
    };

    const handleBtnEditClicked = (data: any) => {
        setSelected(data)
        setSelectedPayment(data)

    }
    const handleBtnDeleteClicked = async (id: number) => {
        const res = await phanBoPhiApi.delete(id);
        if (res.is_success) {
            SetStatus(PageBaseStatus.is_completed)
            showNotify({ message: "Xóa thành công", type: "success" });
            SetStatus(PageBaseStatus.is_need_reload)
        } else {
            SetStatus(PageBaseStatus.is_completed)
            showNotify({ message: res.message || "Cập nhật thất bại", type: "warning" })

        }
        setSelected([])
        setSelectedPayment([])
        handleReloadPhanBoPhi();
        handleReloadTienThuaHocSinh();
    }
    return (
        <DefaultPopup
            width="60%"
            title={'Hình thức thanh toán'}
            onClose={props.onCancel}
        >
            <Box sx={{ height: 'auto' }}>
                <div className="content-wrapper">
                    <div className="left-content">
                        <div style={{ marginLeft: 10, fontWeight: 500, fontSize: 15 }}>
                            Số tiền khả dụng: <span style={{ color: 'green', fontWeight: 'bold', marginLeft: 5, marginRight: 5 }}>
                                {(tong_tien_thua_temp - tong_tien_tra_truoc < 0 ? 0 : tong_tien_thua_temp - tong_tien_tra_truoc).toLocaleString()}
                            </span>
                            VNĐ
                        </div>
                        <hr />
                        <div className="header">Hình thức thanh toán</div>
                        <Box sx={{ height: 'auto', width: 'auto' }}>
                            <ListHinhThucThanhToan />
                        </Box>

                    </div>
                    <div className="right-content">
                        <div className="header">Thông tin thanh toán</div>
                        <Box sx={{ height: 'auto', width: 'auto', overflowX: "scroll", overflowY: 'hidden' }}>

                            <div className="dinh_muc padding-5">
                                <p className="margin-bottom-5">Tổng định mức: <b className="float-right">{props.sf_mucphaithu.tong_tien_dinh_muc.toLocaleString()}</b></p>
                                <p className="margin-bottom-5">Tổng miễn giảm: <b className="float-right">{props.sf_mucphaithu.tong_tien_mien_giam.toLocaleString()}</b></p>
                            </div>
                            <div className="phai_nop padding-5">
                                <p className="margin-bottom-5 float-left">Tổng phải nộp: <b className="float-right">{props.sf_mucphaithu.tong_tien_phai_nop.toLocaleString()}</b></p>
                                {datasource.length > 0 && (
                                    <p className="margin-bottom-5 float-left">Đã nộp: <b className="float-right p-blueberry-700-color">
                                        {(sf_phanbophis.map(x => x.so_tien).reduce((a, b) => a + b, 0)).toLocaleString()}
                                    </b></p>
                                )}
                                {datasource.length > 0 && (
                                    <p className="margin-bottom-5 float-left">
                                        Còn lại:
                                        <b className="float-right p-strawberry-700-color">
                                            {(() => {
                                                console.log({ selectedTienThua: selectedTienThua })

                                                const amount = props.sf_mucphaithu.tong_tien_phai_nop
                                                    - ((selected && selected.hinh_thuc_thanh_toan && selected.hinh_thuc_thanh_toan.toLowerCase().includes("trả trước")
                                                        ? 0
                                                        : (selected?.so_tien || 0)))
                                                    + (selectedPayment?.so_tien || 0)
                                                    - (sf_phanbophis.map(x => x.so_tien).reduce((a, b) => a + b, 0)) - (selectedTienThua?.so_tien || 0);
                                                return amount !== 0 ? (-1 * amount).toLocaleString() : "0";
                                            })()}
                                        </b>
                                    </p>
                                )}
                            </div>
                        </Box>
                        <hr />
                        {selected &&
                            <>
                                <div className="payment_header">{selected.hinh_thuc_thanh_toan}</div>
                                <Box>

                                    <div className="form_group_payment">
                                        {selected.hinh_thuc_thanh_toan?.toLowerCase().includes("trả trước") &&
                                            <>
                                                <label className="form_label_payment">{'Số tiền:'}</label>
                                                <NumberBox
                                                    value={selectedTienThua.so_tien || 0}
                                                    stylingMode="outlined"
                                                    className="text-box"
                                                    width={'40%'}
                                                    min={0}
                                                    max={tong_tien_thua - tong_tien_tra_truoc <= 0 ? 0 : tong_tien_thua - tong_tien_tra_truoc}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            setSelectedTienThua({ ...selectedTienThua, so_tien: e.value })
                                                        }
                                                    }}
                                                />
                                            </>
                                        }
                                        {!selected.hinh_thuc_thanh_toan?.toLowerCase().includes("trả trước") &&
                                            <>
                                                <label className="form_label_payment">{'Số tiền:'}</label>
                                                <NumberBox
                                                    value={selected.so_tien <= 0 ? 0 : selected.so_tien}
                                                    stylingMode="outlined"
                                                    className="text-box"
                                                    width={'40%'}
                                                    min={0}
                                                    // max={props.sf_mucphaithu.tong_tien_phai_nop}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            setSelected({ ...selected, so_tien: e.value })
                                                        }
                                                    }}
                                                />
                                            </>
                                        }
                                        <label className="form_label_payment">{'Mã CC:'}</label>
                                        <TextBox
                                            value={selected.ma_chuan_chi}
                                            stylingMode="outlined"
                                            className="text-box"
                                            width={'40%'}
                                            onValueChanged={(e) => {
                                                if (e.event) {
                                                    setSelected({ ...selected, ma_chuan_chi: e.value })
                                                }
                                            }}
                                        />
                                    </div>
                                    {selected.hinh_thuc_thanh_toan?.toLowerCase().includes("trả trước") &&
                                        <>
                                            <div className="form_group_payment">
                                                <label className="form_label_payment">{'Tiền thừa:'}</label>
                                                <NumberBox
                                                    value={tong_tien_thua_temp - tong_tien_tra_truoc < 0 ? 0 : tong_tien_thua_temp - tong_tien_tra_truoc}
                                                    stylingMode="outlined"
                                                    className="text-box"
                                                    width={'40%'}
                                                    min={0}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            // setSelected({ ...selected, so_tien_thua: e.value })
                                                        }
                                                    }}
                                                />
                                                <label className="form_label_payment">{'Serial:'}</label>
                                                <TextBox
                                                    value={selected.serial}
                                                    stylingMode="outlined"
                                                    className="text-box"
                                                    width={'40%'}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            setSelected({ ...selected, serial: e.value })
                                                        }

                                                    }}
                                                />
                                            </div>
                                            <div className="form_group_payment">
                                                <label className="form_label_payment">{'Ngày thu:'}</label>
                                                <DateBox
                                                    width={'40%'}
                                                    value={selected.ngay_thu}
                                                    onValueChange={(value) => {
                                                        const fullDate = moment(value).format("YYYY-MM-DD HH:mm:ss");
                                                        setSelected({ ...selected, ngay_thu: fullDate });
                                                    }}
                                                    displayFormat={"dd-MM-yyyy"}
                                                    dateSerializationFormat={"yyyy-MM-ddTHH:mm:ss"}
                                                />


                                                <label className="form_label_payment">{'Ghi chú:'}</label>
                                                <TextBox
                                                    value={selected.ghi_chu}
                                                    stylingMode="outlined"
                                                    // className="text-box"
                                                    width={'40%'}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            setSelected({ ...selected, ghi_chu: e.value })
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </>
                                    }
                                    {!selected.hinh_thuc_thanh_toan?.toLowerCase().includes("trả trước") &&
                                        <>
                                            <div className="form_group_payment">
                                                <label className="form_label_payment">{'Ngày thu:'}</label>
                                                <DateBox
                                                    width={'40%'}
                                                    value={selected.ngay_thu}
                                                    onValueChange={(value) => {
                                                        const fullDate = moment(value).format("YYYY-MM-DD HH:mm:ss");
                                                        setSelected({ ...selected, ngay_thu: fullDate });
                                                    }}
                                                    displayFormat={"dd-MM-yyyy"}
                                                    dateSerializationFormat={"yyyy-MM-ddTHH:mm:ss"}
                                                />


                                                <label className="form_label_payment">{'Serial:'}</label>
                                                <TextBox
                                                    value={selected.serial}
                                                    stylingMode="outlined"
                                                    className="text-box"
                                                    width={'40%'}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            setSelected({ ...selected, serial: e.value })
                                                        }

                                                    }}
                                                />
                                            </div>
                                            <div className="form_group_payment">
                                                <label className="form_label_payment">{'Ghi chú:'}</label>
                                                <TextBox
                                                    value={selected.ghi_chu}
                                                    stylingMode="outlined"
                                                    // className="text-box"
                                                    width={'90%'}
                                                    onValueChanged={(e) => {
                                                        if (e.event) {
                                                            setSelected({ ...selected, ghi_chu: e.value })
                                                        }
                                                    }}
                                                />

                                            </div>
                                        </>
                                    }

                                    <div className="pop-up-actions">
                                        <Button type="normal" icon="fas fa-plus" isDisabled={!selected || selected.length === 0 || (props.sf_bienlaithu !== undefined &&
                                            props.sf_bienlaithu.length > 0) || selected.so_tien === 0 || (selectedTienThua && selectedTienThua.so_tien === 0)} isLoading={status === PageBaseStatus.is_saving} text="Cập nhật" isSubmitButton={true} onClick={handleSaveChanges}></Button>
                                    </div>
                                </Box>
                            </>
                        }
                    </div>
                </div>
            </Box>


            <Box sx={{ height: 'auto', m: 3 }}>
                <div className="row">
                    <DataGrid
                        keyExpr="id"
                        dataSource={sf_phanbophis}
                        columnHidingEnabled={false}
                        columnAutoWidth={true}
                        showBorders={false}
                        showColumnLines={true}
                        showRowLines={true}
                        rowAlternationEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode={"nextColumn"}
                        hoverStateEnabled={true}
                        focusedRowEnabled={true}
                        height={window.innerHeight - 650}
                        className={"table-noborder-left table-white-space"}
                        noDataText="Không có dữ liệu"
                        wordWrapEnabled={true}
                        loadPanel={{ enabled: false }}
                        paging={{ enabled: false }}

                    >
                        <Selection mode="single" />
                        {(props.sf_bienlaithu !== undefined &&
                            props.sf_bienlaithu.length === 0) &&
                            <Column visibleIndex={1} width={50} caption="#" alignment="center"
                                cellRender={(cell) => (
                                    <>
                                        <a id={`btnEdit${cell.data.id}`} style={{ cursor: "pointer", color: "#3c22ff" }}>
                                            <i onClick={() => handleBtnEditClicked(cell.data)} className="cmd-edit-icon fas fa-edit ql-color-blue"></i>
                                        </a>
                                        <a id={`btnDelte${cell.data.id}`} style={{ cursor: "pointer", color: "red", marginLeft: 5 }}>
                                            <i onClick={() => handleBtnDeleteClicked(cell.data.id)} className="cmd-edit-icon fas fa-trash"></i>
                                        </a>
                                    </>
                                )}
                            />
                        }
                        <Column visibleIndex={2} dataField="hinh_thuc_thanh_toan" caption="Tên hình thức" minWidth={100} />,
                        <Column visibleIndex={3} dataField="so_tien" caption="Số tiền" format=",##0" minWidth={100} />,
                        <Column visibleIndex={4} allowFiltering={true} dataField="ma_chuan_chi" caption="Mã chuẩn chi" minWidth={100} />,
                        {/* <Column visibleIndex={5} dataField="phi_quet_the" caption="Phí quẹt thẻ" format=",##0" minWidth={100} />, */}
                        <Column visibleIndex={5} dataField="serial" caption="Serial" minWidth={100} />,
                        <Column visibleIndex={6} dataField="ghi_chu" caption="Ghi chú" minWidth={100} />,
                        <Column visibleIndex={7} dataField="ngay_thu" caption="Ngày thu" minWidth={100} type={'date'}
                            dataType="datetime"
                            format="dd/MM/yyyy" />,

                        <Summary>
                            <TotalItem
                                column="so_tien"
                                summaryType="sum"
                                valueFormat=",##0"
                                displayFormat="{0}"
                            />
                            <TotalItem
                                column="phi_quet_the"
                                summaryType="sum"
                                valueFormat=",##0"
                                displayFormat="{0}"
                            />
                        </Summary>
                    </DataGrid>

                </div>
            </Box>
            <div className="pop-up-actions">
                <Button onClick={props.onCancel} icon="fa fa-times" text="Đóng" />{' '}
                {/* <Button type="normal" icon="fas fa-check-square" onClick={handleSaveChanges} text="Cập nhật" isLoading={status === PageBaseStatus.is_saving} /> */}
            </div>

        </DefaultPopup>
    );
}
export default ThuPhiHinhThucThuPhiBtn